import { Injectable } from '@angular/core';

export const authToken = 'authToken';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  set(key: string, value: string) { localStorage.setItem(key, value); }
  get(key: string): string { return localStorage.getItem(key); }
  remove(key: string) { localStorage.removeItem(key); }
  clear() { localStorage.clear(); }
}
